;(function () {
  const formatMoney = (t, e) => {
    function n(t, e) {
      return void 0 === t ? e : t
    }

    function o(t, e, o, i) {
      if (((e = n(e, 2)), (o = n(o, ',')), (i = n(i, '.')), isNaN(t) || null == t)) return 0
      var r = (t = (t / 100).toFixed(e)).split('.')
      return r[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + o) + (r[1] ? i + r[1] : '')
    }

    'string' == typeof t && (t = t.replace('.', ''))
    var i = '',
      r = /\{\{\s*(\w+)\s*\}\}/,
      a = e || Shopify.money_format || '{{ amount_with_comma_separator }}'
    switch (a.match(r)[1]) {
      case 'amount':
        i = o(t, 2)
        break
      case 'amount_no_decimals':
        i = o(t, 0)
        break
      case 'amount_with_comma_separator':
        i = o(t, 2, '.', ',')
        break
      case 'amount_with_space_separator':
        i = o(t, 2, ' ', ',')
        break
      case 'amount_with_period_and_space_separator':
        i = o(t, 2, ' ', '.')
        break
      case 'amount_no_decimals_with_comma_separator':
        i = o(t, 0, '.', ',')
        break
      case 'amount_no_decimals_with_space_separator':
        i = o(t, 0, ' ')
        break
      case 'amount_with_apostrophe_separator':
        i = o(t, 2, "'", '.')
    }
    return a.replace(r, i)
  }

  let cartTotalInCents = +document.querySelector('.js-cart-extrasProduct').dataset.cartTotalInCents
  document.querySelectorAll('.js-cart-extrasProduct').forEach(extrasEl => {
    let lineItemId = extrasEl.dataset.lineItemId
    let priceInCents = +extrasEl.dataset.priceInCents

    const removeLineItem = e => {
      e?.preventDefault()

      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: `${lineItemId}`, quantity: 0 }),
      })
        .then(() => {
          document.querySelectorAll(`.js-cart-extraLineItem[data-line-item-id="${lineItemId}"]`).forEach(el => el.remove())
          lineItemId = null
          extrasEl.classList.remove('in-cart')
          extrasEl.textContent = 'Hinzufügen'
          cartTotalInCents += priceInCents
          document.querySelectorAll('.js-cart-total').forEach(cartTotalEl => {
            cartTotalEl.textContent = `${formatMoney(cartTotalInCents)}€`
            // Add the popPrice class to the price element to make animation
            cartTotalEl.classList.add('popPrice')
            // Remove the popPrice class once the animation is complete
            setTimeout(() => cartTotalEl.classList.remove('popPrice'), 300) // The duration of the animation in milliseconds
          })

          priceInCents = -priceInCents
        })
        .catch(error => console.error('Error:', error))
    }

    if (lineItemId) {
      document
        .querySelectorAll(`.js-cart-extra-remove[data-line-item-id="${lineItemId}"]`)
        .forEach(el => el.addEventListener('click', removeLineItem))
    }

    extrasEl.addEventListener('click', e => {
      e.preventDefault()

      if (lineItemId) {
        removeLineItem()
      } else {
        const variantId = extrasEl.dataset.variantId
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
        })
          .then(r => r.json())
          .then(r => {
            lineItemId = r.items[0].id
            extrasEl.classList.add('in-cart')
            extrasEl.textContent = 'Entfernen'
            cartTotalInCents += priceInCents
            const cartExtraProductLineItem = `
              <div class="row cartExtraLineItem js-cart-extraLineItem" data-line-item-id="${lineItemId}">
                <div class="xs-12 md-12">
                  <div class="value js-cart-extra-product-title">${extrasEl.dataset.productTitle}</div>
                </div>
                <div class="xs-4 md-4 text-right">
                  <div class="price">
                    <span class="woocommerce-Price-amount amount">${formatMoney(priceInCents)}€</span>
                  </div>
                </div>
                <a href="#" class="cartRemove remove close js-cart-extra-remove" data-line-item-id="${lineItemId}">
                  ×
                </a>
              </div>
            `
            document
              .querySelectorAll('.js-cart-deliveryWrapper')
              .forEach(el => el.insertAdjacentHTML('beforebegin', cartExtraProductLineItem))

            const newlyAddedLineItemEl = [
              ...document.querySelectorAll(`.js-cart-extraLineItem[data-line-item-id="${lineItemId}"] .js-cart-extra-remove`),
            ].at(-1)
            newlyAddedLineItemEl.addEventListener('click', removeLineItem)

            document.querySelectorAll('.js-cart-total').forEach(el => {
              el.textContent = `${formatMoney(cartTotalInCents)}€`
              // Add the popPrice class to the price element to make animation
              el.classList.add('popPrice')
              // Remove the popPrice class once the animation is complete
              setTimeout(() => el.classList.remove('popPrice'), 300) // The duration of the animation in milliseconds
            })

            priceInCents = -priceInCents
          })
          .catch(error => console.error('Error:', error))
      }
    })

    document.querySelector('.js-cart-delete').addEventListener('click', e => {
      e.preventDefault()

      fetch('/cart/clear.js', { method: 'POST', headers: { 'Content-Type': 'application/json' } })
        .then(() => (window.location.href = '/pages/brillenglas-konfigurator'))
        .catch(error => console.error('Error:', error))
    })
  })
})()
